import React from 'react'
import { t } from 'src/translations'

type MoreButtonProps = {
  isTruncated: boolean
  isExpanded: boolean
  onClick: () => void
  color: string
  isEditor: boolean
}

const MoreButton = ({
  isTruncated,
  isExpanded,
  onClick,
  color,
  isEditor
}: MoreButtonProps) => {
  if (!isTruncated) return null

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    onClick()
  }

  return (
    <button
      onMouseDown={isEditor ? handleClick : undefined}
      onClick={!isEditor ? handleClick : undefined}
      className='reviewMoreButton'
      style={{ color }}
      aria-expanded={isExpanded}
    >
      {isExpanded ? t('reviews.less') : t('reviews.more')}
    </button>
  )
}

export default MoreButton
